import React from 'react';

const BreadcrumbNav = ({ 
  currentView, 
  selectedLead, 
  selectedInstaller, 
  onNavigate 
}) => {
  const getBreadcrumbs = () => {
    const breadcrumbs = [
      { label: 'Dashboard', path: 'overview', icon: '🏠' }
    ];

    switch (currentView) {
      case 'leads':
        breadcrumbs.push({ label: 'Leads', path: 'leads', icon: '👥', current: true });
        break;
      case 'lead-detail':
        breadcrumbs.push(
          { label: 'Leads', path: 'leads', icon: '👥' },
          { 
            label: selectedLead?.primary_business_name || 'Lead Details', 
            path: 'lead-detail', 
            icon: '📋',
            current: true 
          }
        );
        break;
      case 'search':
        breadcrumbs.push({ label: 'Search', path: 'search', icon: '🔍', current: true });
        break;
      case 'detail':
        breadcrumbs.push(
          { label: 'Search', path: 'search', icon: '🔍' },
          { 
            label: selectedInstaller?.company_name || 'Installer Details', 
            path: 'detail', 
            icon: '🏢',
            current: true 
          }
        );
        break;
      case 'settings':
        breadcrumbs.push({ label: 'Settings', path: 'settings', icon: '⚙️', current: true });
        break;
      default:
        breadcrumbs.push({ label: 'Overview', path: 'overview', icon: '📊', current: true });
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav style={styles.breadcrumbContainer} aria-label="Breadcrumb navigation">
      <ol style={styles.breadcrumbList}>
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={breadcrumb.path} style={styles.breadcrumbItem}>
            {index > 0 && (
              <span style={styles.separator} aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </span>
            )}
            {breadcrumb.current ? (
              <span 
                style={styles.currentBreadcrumb}
                aria-current="page"
              >
                <span style={styles.breadcrumbIcon}>{breadcrumb.icon}</span>
                {breadcrumb.label}
              </span>
            ) : (
              <button
                style={styles.breadcrumbLink}
                onClick={() => onNavigate(breadcrumb.path)}
                aria-label={`Navigate to ${breadcrumb.label}`}
              >
                <span style={styles.breadcrumbIcon}>{breadcrumb.icon}</span>
                {breadcrumb.label}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

const styles = {
  breadcrumbContainer: {
    padding: '16px 0',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    marginBottom: '24px'
  },
  breadcrumbList: {
    display: 'flex',
    alignItems: 'center',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    flexWrap: 'wrap',
    gap: '8px'
  },
  breadcrumbItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  separator: {
    color: 'rgba(255, 255, 255, 0.4)',
    display: 'flex',
    alignItems: 'center'
  },
  breadcrumbLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1)',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      color: '#ffffff',
      transform: 'translateY(-1px)'
    },
    '&:focus': {
      outline: '2px solid #3B82F6',
      outlineOffset: '2px'
    }
  },
  currentBreadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    background: 'rgba(59, 130, 246, 0.2)',
    border: '1px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    color: '#3B82F6',
    fontSize: '14px',
    fontWeight: '600'
  },
  breadcrumbIcon: {
    fontSize: '16px'
  }
};

export default BreadcrumbNav; 